/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { InputListboxContextValues } from '@fluentui-copilot/react-input-listbox';
import { renderInputListbox_unstable } from '@fluentui-copilot/react-input-listbox';
import type { GroundingMenuListboxState, GroundingMenuListboxSlots } from './GroundingMenuListbox.types';

/**
 * Render the final JSX of GroundingMenuListbox
 */
export const renderGroundingMenuListbox_unstable = (
  state: GroundingMenuListboxState,
  contextValues: InputListboxContextValues,
): JSXElement => {
  assertSlots<GroundingMenuListboxSlots>(state);

  return renderInputListbox_unstable(state, contextValues);
};
